import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "7 6.5 42 42"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#4C4DEE",
  d: "M11.958 48.125q-1.89 0-3.237-1.346-1.346-1.347-1.346-3.237V11.458q0-1.89 1.346-3.237 1.347-1.346 3.237-1.346h13.75q.975 0 1.633.659.66.659.659 1.633 0 .973-.659 1.633-.659.658-1.633.658h-13.75v32.084h32.084v-13.75q0-.975.658-1.633.66-.66 1.633-.659.975 0 1.633.659.66.659.659 1.633v13.75q0 1.89-1.346 3.237-1.347 1.346-3.237 1.346zm32.084-33.458L24.333 34.375q-.63.63-1.604.63t-1.604-.63-.63-1.604.63-1.604l19.708-19.709h-5.958q-.975 0-1.633-.659-.659-.659-.659-1.632 0-.975.66-1.633.658-.66 1.632-.659h11.458q.975 0 1.633.659.66.659.659 1.633v11.458q0 .975-.659 1.633-.659.659-1.633.659-.973 0-1.633-.66-.658-.658-.658-1.632z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }